export default __webpack_public_path__ + "static/media/yournewslogo.f6499086.png";